import { render, staticRenderFns } from "./fundraisers.vue?vue&type=template&id=079e0757&scoped=true"
import script from "./fundraisers.vue?vue&type=script&lang=ts"
export * from "./fundraisers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079e0757",
  null
  
)

export default component.exports